// REACT & REDUX
import { connect } from "react-redux";

// STYLE, PROPS & TRANSLATIONS

// COMMON

// COMPONENTS
import Home from "./Home.component";

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps)(Home);
